import { Button, createStyles, IconButton, makeStyles, styled } from '@material-ui/core';
import { IMG_BG } from 'shared/constants/ASSETS_URL';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_CONTAINER_FIELDS_ON_CARD,
  DARK_CONTAINER_FIELDS_FLOATING,
  DARK_SECONDARY_BUTTONBACKGROUND,
  LIGHT_CONTAINER_FIELDS_FLOATING,
  DARK_TEXT,
  DARKER_CONTAINER_TRANSPARENT,
  ERROR_TEXT,
  LIGHT_CONTAINER_FIELDS_ON_CARD,
  LIGHT_FIELDS_FLOATING_BUTTON_BACKGROUND,
  LIGHT_TEXT,
  OFFWHITE_CONTAINER_TRANSPARENT,
  PRIMARY_CONTAINER_BORDER,
  PRIMARY_BUTTON_BORDER,
} = COLORS;

export const useStyles = makeStyles((theme) =>
  createStyles({
    mainCont: {
      display: 'flex',
      [theme.breakpoints.down(960)]: {
        flexDirection: 'column',
      },
    },
    root: {
      height: 'fit-content',
      display: 'flex',
      flexWrap: 'nowrap',
      gap: 10,
      alignItems: 'flex-start',
      width: '100%',
      borderRadius: 8,
      padding: 10,
      backgroundImage:
        theme.palette.type === 'dark'
          ? `linear-gradient(270deg, ${DARKER_CONTAINER_TRANSPARENT} 0%, ${DARK_CONTAINER_FIELDS_FLOATING} 30%), url(${IMG_BG})`
          : `linear-gradient(270deg, ${OFFWHITE_CONTAINER_TRANSPARENT} 0%, ${LIGHT_CONTAINER_FIELDS_FLOATING} 30%), url(${IMG_BG})`,
      backgroundSize: 'auto 100%',

      [theme.breakpoints.down(960)]: {
        backgroundImage:
          theme.palette.type === 'dark'
            ? `linear-gradient(0deg, ${DARKER_CONTAINER_TRANSPARENT} 0%, ${DARK_CONTAINER_FIELDS_FLOATING} 50%), url(${IMG_BG})`
            : `linear-gradient(0deg, ${OFFWHITE_CONTAINER_TRANSPARENT} 0%, ${LIGHT_CONTAINER_FIELDS_FLOATING} 30%), url(${IMG_BG})`,
        flexDirection: 'column',
        alignItems: 'start',
      },
      '& .MuiFormControl-root': {
        marginTop: 0,
        marginBottom: 0,
      },
    },
    qrContainer: {
      height: 43,
      width: 100,
      background:
        theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_ON_CARD : LIGHT_CONTAINER_FIELDS_ON_CARD + '!important',
      border: `1px solid ${PRIMARY_CONTAINER_BORDER}`,
      backgroundOrigin: 'border-box',
      backgroundClip: 'content-box, border-box',
      borderRadius: '8px !important',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      [theme.breakpoints.down(960)]: {
        width: 100,
        height: 70,
        alignSelf: 'center',
      },
    },
    input: {
      width: 400,
      '& .MuiInputBase-root': {
        height: '44px!important',
        '& fieldset': {
          borderRadius: 8,
          border: `solid 1px ${PRIMARY_BUTTON_BORDER}`,
        },
      },

      '& .MuiInputAdornment-positionStart': {
        marginRight: 15,
      },

      '& .MuiSvgIcon-root': {
        fontSize: 20,
      },

      '& input::placeholder': {
        color: LIGHT_TEXT,
        letterSpacing: 0.4,
        fontWeight: 500,
        opacity: 0.9,
      },

      '& .MuiFormHelperText-root': {
        color: ERROR_TEXT,
        fontSize: 14,
      },

      [theme.breakpoints.down(960)]: {
        width: '100%',
      },
    },
    buttonCls: {
      width: 160,
      height: '44px !important',
      borderRadius: 8,
      textTransform: 'unset',
      fontSize: 15,
      [theme.breakpoints.down(960)]: {
        width: '100%',
      },
    },
  }),
);

export const PastContainer = styled(Button)(() => ({
  background: DARK_CONTAINER_FIELDS_ON_CARD,
  borderRadius: 8,
  width: '100%',
  minWidth: 400,
  '& > span': {
    display: 'flex',
    alignItems: 'center',
    gap: 15,
  },

  padding: '10px 15px',
}));

export const PastCount = styled('div')(() => ({
  height: 31,
  width: 31,
  borderStyle: 'solid',
  borderWidth: '2px',
  borderImageSlice: '1',
  backgroundOrigin: 'border-box',
  backgroundClip: 'content-box, border-box',
  borderRadius: '25px !important',
  WebkitBorderRadius: '25px !important',
  WebkitMaskImage: '-webkit-radial-gradient(circle, white 100%, black 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const PastTextContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',

  '& > p': {
    lineHeight: 1.2,
  },
}));

export const CustomIconButton = styled(IconButton)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: 'auto',

  '& .MuiSvgIcon-root': {
    width: 11,
    height: 11,
  },

  '&:hover': {
    backgroundColor: 'unset',
  },
}));
